import React from "react";

import "../styles/AboutPage.css";

const AboutPage = () => {

  return (

    <main className="luxury-about">

      {/* ================= HERO ================= */}

      <section className="about-hero">

        {/* FAST LOADING HERO IMAGE */}

        <img
          src="https://i.ibb.co/cS1d9nfp/sac-mtb-about-us-bicycle-nature.png"
          alt="SAC Universe"
          className="about-video"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          width="1920"
          height="1080"
        />

        <div className="about-overlay">

          <span>
            WELCOME TO THE SAC UNIVERSE
          </span>

          <h1>
            MORE THAN <br />
            JUST RIDES
          </h1>

          <p>
            SAC is building a futuristic
            world where bicycles, ride-on
            toys, gaming, adventure and
            nature become one unforgettable
            experience.
          </p>

        </div>

      </section>

      {/* ================= BIG STATEMENT ================= */}

      <section className="about-statement">

        <h1>
          RIDE. <br />
          DREAM. <br />
          EVOLVE.
        </h1>

      </section>

      {/* ================= WHY BICYCLES ================= */}

      <section className="editorial-story">

        <div className="story-image">

          <img
            src="https://i.ibb.co/cS1d9nfp/sac-mtb-about-us-bicycle-nature.png"
            alt="SAC Bicycles"
            loading="lazy"
            decoding="async"
            width="900"
            height="1100"
          />

        </div>

        <div className="story-content">

          <span>
            WHY BICYCLES
          </span>

          <h2>
            CLOSER TO <br />
            NATURE. <br />
            CLOSER TO LIFE.
          </h2>

          <p>
            SAC began with one simple
            belief — the world feels
            different when explored on
            two wheels.
          </p>

          <p>
            Bicycles are not just about
            riding. They reconnect people
            with nature, fresh air,
            freedom and real experiences
            that are often lost in fast
            modern lifestyles.
          </p>

          <p>
            Every ride creates a moment
            to slow down, explore new
            paths, feel the mountains,
            discover hidden roads and
            reconnect with the outdoors.
          </p>

          <p>
            We chose bicycles because
            they represent sustainable
            mobility, adventure and a
            healthier future for the next
            generation.
          </p>

          <p>
            SAC MTB was built to inspire
            people to leave the ordinary
            behind and experience the
            beauty of movement, nature
            and exploration in a more
            meaningful way.
          </p>

        </div>

      </section>

      {/* ================= WHY TOYS ================= */}

      <section className="mission-editorial">

        <div className="mission-box">

          <span>
            WHY RIDE-ON TOYS
          </span>

          <h2>
            BUILDING <br />
            THE NEXT <br />
            GENERATION
          </h2>

          <p>
            While building bicycles for
            riders, we realized something
            powerful — every rider’s
            journey begins in childhood.
          </p>

          <p>
            That inspired us to create
            futuristic ride-on toys where
            children can experience
            imagination, adventure and
            mobility from an early age.
          </p>

          <p>
            SAC Toys combines cinematic
            design, luxury styling and
            futuristic experiences to
            create unforgettable memories
            for the next generation.
          </p>

          <p>
            We want children to dream
            bigger, explore fearlessly
            and grow with the same love
            for movement, exploration
            and adventure that inspired
            SAC from the beginning.
          </p>

        </div>

        <div className="mission-image">

          <img
            src="https://i.ibb.co/fVnPWpTp/a59e46cf-aeb5-4835-9dcb-e5a663301fe4.png"
            alt="Ride On Toys"
            loading="lazy"
            decoding="async"
            width="900"
            height="1100"
          />

        </div>

      </section>

      {/* ================= OUR JOURNEY ================= */}

      <section className="luxury-features">

        <h2>
          OUR <br />
          JOURNEY
        </h2>

        <div className="features-grid">

          <div className="feature-card">

            <div className="feature-icon">
              🚴
            </div>

            <h3>
              THE BEGINNING
            </h3>

            <p>
              SAC started with a vision
              to create premium bicycles
              that combine performance,
              adventure and futuristic
              design into one experience.
            </p>

          </div>

          <div className="feature-card">

            <div className="feature-icon">
              🌿
            </div>

            <h3>
              CONNECTING WITH NATURE
            </h3>

            <p>
              Cycling allows people to
              reconnect with nature,
              explore new paths and
              experience the outdoors
              in a healthier way.
            </p>

          </div>

          <div className="feature-card">

            <div className="feature-icon">
              🚗
            </div>

            <h3>
              EXPANDING THE DREAM
            </h3>

            <p>
              We expanded into ride-on
              toys to inspire children
              with futuristic mobility
              experiences and cinematic
              adventures.
            </p>

          </div>

          <div className="feature-card">

            <div className="feature-icon">
              🎮
            </div>

            <h3>
              ENTERING GAMING
            </h3>

            <p>
              SAC is now building a
              futuristic gaming universe
              where riders can compete,
              explore worlds and unlock
              legendary adventures.
            </p>

          </div>

        </div>

      </section>

      {/* ================= STATS ================= */}

      <section className="stats-editorial">

        <div className="stat-box">

          <h1>
            50K+
          </h1>

          <p>
            DREAMERS
          </p>

        </div>

        <div className="stat-box">

          <h1>
            20K+
          </h1>

          <p>
            RIDES CREATED
          </p>

        </div>

        <div className="stat-box">

          <h1>
            TOP 10
          </h1>

          <p>
            MONTHLY PLAYERS
          </p>

        </div>

      </section>

      {/* ================= GAME INTRO ================= */}

      <section className="timeline-editorial">

        <div className="timeline-header">

          <span>
            THE SAC GAME WORLD
          </span>

          <h2>
            PLAY. <br />
            COMPETE. <br />
            WIN.
          </h2>

        </div>

        <div className="timeline-grid">

          {/* CARD 01 */}

          <div className="timeline-card">

            <div className="timeline-image">

              <img
                src="https://i.ibb.co/9dvpf3v/sac-mtb-game-1.png"
                alt="Explore SAC World"
                loading="lazy"
                decoding="async"
                width="700"
                height="900"
              />

            </div>

            <div className="timeline-overlay">

              <span>
                01
              </span>

              <h3>
                EXPLORE
              </h3>

              <p>
                Enter the futuristic SAC
                gaming universe where players
                can explore cities, mountains
                and immersive digital worlds.
              </p>

            </div>

          </div>

          {/* CARD 02 */}

          <div className="timeline-card">

            <div className="timeline-image">

              <img
                src="https://i.ibb.co/PvY7DGcR/sac-mtb-game-2.png"
                alt="Compete"
                loading="lazy"
                decoding="async"
                width="700"
                height="900"
              />

            </div>

            <div className="timeline-overlay">

              <span>
                02
              </span>

              <h3>
                COMPETE
              </h3>

              <p>
                Compete against riders from
                the SAC community and climb
                the leaderboard to become
                one of the Top 10 players
                every month.
              </p>

            </div>

          </div>

          {/* CARD 03 */}

          <div className="timeline-card">

            <div className="timeline-image">

              <img
                src="https://i.ibb.co/WpcmBjvw/sac-mtb-game-3.png"
                alt="Win Bicycle"
                loading="lazy"
                decoding="async"
                width="700"
                height="900"
              />

            </div>

            <div className="timeline-overlay">

              <span>
                03
              </span>

              <h3>
                WIN A BICYCLE
              </h3>

              <p>
                Every month, one rider from
                the Top 10 players will win
                a brand-new SAC bicycle and
                become part of the SAC
                Champions League.
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* ================= ENDING ================= */}

      <section className="ending-editorial">

        <h1>
          THIS IS <br />
          JUST THE <br />
          BEGINNING.
        </h1>

      </section>

    </main>
  );
};

export default AboutPage;